<template>
  <div class="TmTextEdit">
    <!-- {{templateType}} -->
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>

        <!-- 获取数字，静态或动态以及数值运算 -->
        <attr-row :label="$t('lcd.Editor.Number Content')">
          <el-tooltip placement="top" slot="hint">
            <div slot="content">
              {{ $t("lcd.Editor.Single quotation marks") }} <br />
              {{ $t("lcd.Editor.Double quotation marks") }} <br />
              <b style="color: red">{{ $t("lcd.Editor.No replace") }}</b
              ><br />
              <b style="color: red">{{
                $t("lcd.Editor.Replace in English")
              }}</b>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <div style="display: flex; justify-content: space-between">
            <el-input v-model="conf.text" style="width: 49%" size="mini" />
            <!-- 数据动态字段 -->
            <el-select
              v-model="conf.datasetField"
              @change="changeName()"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Feild')"
              style="width: 49%"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
                :disabled="field.type != 'number'"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 数据处理  计算 + 添加前缀后缀 -->
        <attr-row :label="$t('lcd.Editor.NumberFormat')" class="th dir">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.positiveFlag"
              :placeholder="$t('lcd.Editor.positiveFlag')"
              size="mini"
              style="width: 49%"
            />
            <el-input
              v-model="conf.negativeFlag"
              :placeholder="$t('lcd.Editor.negativeFlag')"
              size="mini"
              style="width: 49%"
            />
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.preText"
              :placeholder="$t('lcd.Editor.preText')"
              size="mini"
              style="width: 25%"
            />
            <el-input
              v-model="conf.thousandSeparator"
              :placeholder="$t('lcd.Editor.thousandSeparator')"
              size="mini"
              style="width: 24%"
            />
            <el-input
              v-model="conf.decimalPoint"
              :placeholder="$t('lcd.Editor.decimalPoint')"
              style="width: 24%"
              size="mini"
            />
            <el-input
              v-model="conf.sufText"
              :placeholder="$t('lcd.Editor.sufText')"
              size="mini"
              style="width: 25%"
            />
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.calcType"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select calType')"
              style="width: 49%"
            >
              <el-option
                v-for="field in calcList"
                :key="field"
                :label="field"
                :value="field"
              />
            </el-select>
            <el-input
              v-model="conf.calcNumber"
              controls-position="right"
              type="number"
              size="mini"
              :placeholder="$t('lcd.Editor.Please Input Calc Number')"
              style="width: 49%"
            ></el-input>
          </div>
        </attr-row>

        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>

        <!-- 数字样式设置 -->
        <attr-row
          :label-width="0"
          class="custom-color-picker custom-smaller-btn"
        >
          <!-- 价签字体颜色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeFontColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
          </div>
          <!-- 价签填充色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBgColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
            <img @click="conf.bgColor = 'rgba(0,0,0,0)'" :src="transparentBg" style="width: 18px;height:18px;">
          </div>

          <div style="display: flex; align-items: center">
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; color: #000"
              v-if="!pageColor"
            ></i>
            <el-color-picker
              v-model="conf.fontColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
              v-if="!pageColor"
            />
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin-left: 6px;color: #000"
              v-if="!pageColor"
            ></i>
            <el-color-picker
              v-model="conf.bgColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
              style="margin-right: 8px;"
              v-if="!pageColor"
            />
            <!-- 小数显示设置 -->
            <el-button-group>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('lcd.Editor.Top Drift')"
                placement="top"
              >
                <el-button
                  size="small"
                  :type="conf.fontSpecial == 1 ? 'primary' : ''"
                  @click="handleChangeFontSpecial(1)"
                >
                  <i
                    class="icon iconfont icon-zitishangbiao"
                    style="font-size: 12px; height: 12px; line-height: 12px"
                  ></i>
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('lcd.Editor.Bottom Drift')"
                placement="top"
              >
                <el-button
                  size="small"
                  :type="conf.fontSpecial == 2 ? 'primary' : ''"
                  @click="handleChangeFontSpecial(2)"
                >
                  <i
                    class="icon iconfont icon-zitixiabiao"
                    style="font-size: 12px; height: 12px; line-height: 12px"
                  ></i>
                </el-button>
              </el-tooltip>
            </el-button-group>
            <!-- 漂移分隔符 -->
            <el-input
              :placeholder="$t('lcd.Editor.Drift Flag')"
              v-model="conf.fontSpecialChar"
              style="width: 100px; margin-left: 10px; float: right"
              size="mini"
            ></el-input>
          </div>
        </attr-row>

        <attr-row :label-width="0" class="custom-smaller-btn">
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Left')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-start' ? 'primary' : ''"
                @click="changeTA('flex-start')"
              >
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Horizontal')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'center' ? 'primary' : ''"
                @click="changeTA('center')"
              >
                <i
                  class="icon iconfont icon-chuizhijuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Right')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-end' ? 'primary' : ''"
                @click="changeTA('flex-end')"
              >
                <i
                  class="icon iconfont icon-youduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Top')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-start' ? 'primary' : ''"
                @click="changeVA('flex-start')"
              >
                <i
                  class="icon iconfont icon-shangduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Vertical')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'center' ? 'primary' : ''"
                @click="changeVA('center')"
              >
                <i
                  class="icon iconfont icon-shuipingjuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Bottom')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-end' ? 'primary' : ''"
                @click="changeVA('flex-end')"
              >
                <i
                  class="icon iconfont icon-xiaduiqi"
                  style="font-size: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
        </attr-row>

        <!-- 前缀样式 -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Pre Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.preTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.preTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.preTextStyle.isUnderline === 'underline' ? 'primary' : ''
                "
                @click="handleClickUnderline('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.preTextStyle.isUnderline === 'line-through'
                    ? 'primary'
                    : ''
                "
                @click="handleClickDeleteline('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" placement="bottom">
              <el-button size="small">
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
              <div slot="content">
                <div
                  :class="[
                    'alignClick',
                    conf.preTextStyle.alignType == '1' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(1, 'preTextStyle')"
                >
                  {{ $t("lcd.Editor.Align to Top") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.preTextStyle.alignType == '2' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(2, 'preTextStyle')"
                >
                  {{ $t("lcd.Editor.Align Center in Vertical") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.preTextStyle.alignType == '3' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(3, 'preTextStyle')"
                >
                  {{ $t("lcd.Editor.Align to Bottom") }}
                </div>
              </div>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.preTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.preTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 整数样式integerTextStyle -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Integer Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.integerTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('integerTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.integerTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('integerTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.integerTextStyle.isUnderline === 'underline'
                    ? 'primary'
                    : ''
                "
                @click="handleClickUnderline('integerTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.integerTextStyle.isUnderline === 'line-through'
                    ? 'primary'
                    : ''
                "
                @click="handleClickDeleteline('integerTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.integerTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.integerTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 小数点样式decimalPointTextStyle -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Decimal Point Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.decimalPointTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('decimalPointTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.decimalPointTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('decimalPointTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.decimalPointTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.decimalPointTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 小数样式decimalTextStyle -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Decimal Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.decimalTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('decimalTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.decimalTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('decimalTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.decimalTextStyle.isUnderline === 'underline'
                    ? 'primary'
                    : ''
                "
                @click="handleClickUnderline('decimalTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.decimalTextStyle.isUnderline === 'line-through'
                    ? 'primary'
                    : ''
                "
                @click="handleClickDeleteline('decimalTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.decimalTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.decimalTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 后缀样式 -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Suffix Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.sufTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('sufTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.sufTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('sufTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.sufTextStyle.isUnderline === 'underline' ? 'primary' : ''
                "
                @click="handleClickUnderline('sufTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.sufTextStyle.isUnderline === 'line-through'
                    ? 'primary'
                    : ''
                "
                @click="handleClickDeleteline('sufTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" placement="bottom">
              <el-button size="small">
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
              <div slot="content">
                <div
                  :class="[
                    'alignClick',
                    conf.sufTextStyle.alignType == '1' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(1, 'sufTextStyle')"
                >
                  {{ $t("lcd.Editor.Align to Top") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.sufTextStyle.alignType == '2' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(2, 'sufTextStyle')"
                >
                  {{ $t("lcd.Editor.Align Center in Vertical") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.sufTextStyle.alignType == '3' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(3, 'sufTextStyle')"
                >
                  {{ $t("lcd.Editor.Align to Bottom") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.sufTextStyle.alignType == '4' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(4, 'sufTextStyle')"
                >
                  {{ $t("lcd.Editor.Align above decimals") }}
                </div>
                <div
                  :class="[
                    'alignClick',
                    conf.sufTextStyle.alignType == '5' ? 'currentAlign' : '',
                  ]"
                  @click="alignTypeClick(5, 'sufTextStyle')"
                >
                  {{ $t("lcd.Editor.Align below decimals") }}
                </div>
              </div>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.sufTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.sufTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 保留小数位数 -->
        <attr-row :label="$t('lcd.Editor.decimalplaces')" class="tt">
          <el-select
            v-model="conf.decimalplaces"
            size="mini"
            style="width: 100%"
          >
            <el-option
              v-for="item in 6"
              :key="item - 1"
              :label="item - 1"
              :value="item - 1"
            />
          </el-select>
        </attr-row>

        <!-- 舍入模式 -->
        <attr-row :label="$t('lcd.Editor.Rounding Mode')" class="tt">
          <el-select
            v-model="conf.roundingMode"
            size="mini"
            style="width: 100%"
          >
            <el-option
              v-for="item in roundingModeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </attr-row>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>

        <!-- 超出显示效果 -->
        <attr-row :label="$t('lcd.Editor.Beyond display')" class="tt">
          <el-radio-group v-model="conf.exceedingDisplay">
            <el-radio size="mini" label="1">{{
              $t("lcd.Editor.Beyond hidden")
            }}</el-radio>
            <el-radio size="mini" label="2">{{
              $t("lcd.Editor.Autoscale")
            }}</el-radio>
          </el-radio-group>
        </attr-row>
      </el-tab-pane>
    </el-tabs>

    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import {
  predefineColors,
  colorList,
  fontList,
  fontSizeList,
  calcList,
  roundingModeList,
} from "../../../utils/constant.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import LogicDialog from "../../tumeng-display/src/index.vue";
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";

export default {
  name: "TumengTextEdit",
  props: {
    goodsFields: {
      type: Array,
      default: function () {
        return [];
      },
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: { AttrRow, LogicDialog },
  data() {
    return {
      transparentBg,
      isMore: false,
      fontSpecial: [
        {
          value: 0,
          label: this.$t("lcd.Editor.No Drift"),
        },
        {
          value: 1,
          label: this.$t("lcd.Editor.Top Drift"),
        },
        {
          value: 2,
          label: this.$t("lcd.Editor.Middle Drift"),
        },
        {
          value: 3,
          label: this.$t("lcd.Editor.Bottom Drift"),
        },
      ],
      state: store.state,
      predefineColors,
      colorList,
      allFontList: Array.from(new Set ([...fontList,...JSON.parse(localStorage.getItem('userFontList'))])),
      fontSizeList,
      calcList,
      roundingModeList,
      dictScrollDirection: [
        { label: "无", value: "" },
        { label: "左", value: "left" },
        { label: "右", value: "right" },
        { label: "上", value: "up" },
        { label: "下", value: "down" },
      ],
      // 滚动的intervalId
      intervalId: undefined,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  computed: {
    conf: {
      get() {
        return this.state.activeComponent;
      },
    },
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    templateType() {
      // 0 lcd价签模板   1 营销模板   2 esl价签模板
      return this.state.programInfo.templateGroup;
    },
    clipShapObj() {
      return store.state.activeComponent.clipShap || {};
    },
    // goodsFields() {
    //   let fields = null;
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.templateGroupId
    //   );
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.goodsFields
    //   );
    //   if (store.state.programInfo.templateGroupId == 0) {
    //     fields = store.state.programInfo.goodsFields;
    //   }
    //   if (fields) {
    //     return fields;
    //   }
    //   return undefined;
    // },
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
    changeTA(ta) {
      this.conf.textAlign = ta;
    },
    changeVA(va) {
      this.conf.verticalAlign = va;
    },
    changeName() {
      for (let i = 0; i < this.goodsFields.length; i++) {
        if (
          this.conf.datasetField &&
          this.conf.datasetField === this.goodsFields[i].value
        ) {
          this.conf.name = this.goodsFields[i].label;
        }
        if (!this.conf.datasetField) {
          console.log("静态数字", this.conf.text);
          this.conf.name = this.conf.text ? this.conf.text : "Text";
        }
      }
    },
    handleClickBold(type) {
      this.conf[type].isBold = !this.conf[type].isBold;
    },
    handleClickItaly(type) {
      this.conf[type].isItaly = !this.conf[type].isItaly;
    },
    handleClickUnderline(type) {
      const text =
        this.conf[type].isUnderline === "underline" ? "none" : "underline";
      this.conf[type].isUnderline = text;
    },
    handleChangeFontSpecial(val) {
      // 相同时取消漂移
      // if (this.conf.fontSpecial == val) {
      //   this.conf.fontSpecial = "";
      // } else {
      //   this.conf.fontSpecial = val;
      // }
      this.conf.fontSpecial = val;
    },
    handleClickDeleteline(type) {
      const text =
        this.conf[type].isUnderline === "line-through"
          ? "none"
          : "line-through";
      this.conf[type].isUnderline = text;
    },
    // 改变漂移文字的字体大小
    uploudFontSize(num) {
      let size = this.conf.fontSpecialSize;
      size = size ? size : 32;
      this.conf.fontSpecialSize = size + num;
    },
    // 改变分隔符状态
    fontSpecialChekedChange() {
      store.state.activeComponent.fontSpecialChecked =
        !store.state.activeComponent.fontSpecialChecked;
    },

    alignTypeClick(alignVal, type) {
      console.log(alignVal, type);
      this.conf[type].alignType = alignVal;
    },

    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },
    // 修改文本填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },

    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.TmTextEdit {
  margin: 8px;

  .style-pane {
    // 时长样式
    .duration {
      div.el-input-number {
        width: 100%;
      }

      ::v-deep span.el-input-number__decrease,
      ::v-deep span.el-input-number__increase {
        display: none;
      }

      ::v-deep input.el-input__inner {
        padding: 0 15px;
        text-align: justify;
      }
    }

    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";
    // 加粗、倾斜、下划线那一行按钮变小
    .custom-smaller-btn {
      ::v-deep button.el-button {
        padding: 5px 11px;
      }
      ::v-deep .el-button--primary.is-plain:hover {
        background: #ffffff;
        border: 1px solid #dcdfe6;
        color: #606266;
      }
    }

    // 行高的样式
    .custom-smaller-slider-btn {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 66px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 50px;
        float: left;
        margin-top: 5px;
      }
    }

    // 旋转的样式
    .custom-smaller-slider-btn2 {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }

    .custom-color-picker {
      ::v-deep span.el-color-picker__icon.el-icon-arrow-down {
        display: none;
      }

      ::v-deep div.el-color-picker__trigger {
        border: none;
      }
    }

    // 滚动方向
    .dir {
      .el-radio {
        margin-right: 5px;

        ::v-deep .el-radio__label {
          padding-left: 2px;
        }
      }
    }
  }

  .explain {
    line-height: 30px;
  }
}
.sizeBtn {
  // flex: 1;
  width: 25px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ::v-deep .el-button.el-button--mini {
    font-size: 12px !important;
  }
  ::v-deep .el-button {
    height: 14px;
    padding: 0 5px;
    margin: 0;
  }
}
.custom-smaller-slider-btn2 {
  .radius-box {
    ::v-deep .el-slider {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      float: right !important;
    }
    ::v-deep .el-slider__input {
      width: 60px !important;
    }
    ::v-deep .el-slider__runway.show-input {
      margin-right: 76px !important;
    }
    ::v-deep .el-slider__stop {
      display: none;
    }
    ::v-deep .el-slider__marks-text {
      margin-top: 5px;
    }
  }
}
::v-deep .el-tabs__item.is-active {
  background-color: #f5f7fa !important;
  border-radius: 5px 5px 0 0 !important;
}
.alignClick {
  line-height: 26px;
  font-size: 14px;
  cursor: pointer;
}
.currentAlign {
  color: #35b871;
}
.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
// ::v-deep .el-tabs > .el-tabs__header .el-tabs__item.is-active{
//   background-color: #f5f7fa !important;
//   border-radius: 5px 5px 0 0 !important;
// }
// ::v-deep .miniPadding .el-input-group__prepend {
//   width: 66px !important;
//   overflow: hidden;
//   border-radius:0;
//   text-align: center;
// }
</style>
